module.exports = __webpack_public_path__ + "static/img/paypal-logo.a03d6ffb.png";